import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { ProtectedRoute } from '@shared/components/ProtectedRoute'
import { EmailVerifyRoute } from '@shared/components/EmailVerifyRoute'
import { MfaRoute } from '@shared/components/MfaRoute'
import { LoginPage } from '@features/auth/pages/LoginPage'
import { GuestRoute } from '@shared/components/GuestRoute'
import { VerifyEmailPage } from '@features/auth/pages/VerifyEmailPage'
import { MfaPage } from '@features/auth/pages/MfaPage'
import { ForgotPasswordPage } from '@features/auth/pages/ForgotPasswordPage'
import { ResetPasswordPage } from '@features/auth/pages/ResetPasswordPage'
import DashboardPage from '@features/dashboard/DashboardPage'
import { LogoutPage } from '@features/auth/pages/LogoutPage'
import AppLayout from './layout/AppLayout'
import { ErrorBoundary } from '@shared/components/ErrorBoundary'
import { ChangePasswordPage } from '@features/auth/pages/ChangePasswordPage'
import { UsersPage } from '@features/admin/users/UsersPage'
import SubsidiaryManagement from '@features/subsidiary/SubsidiaryManagement'
import ProjectListing from '@features/project/ProjectListing'
import ProjectDetail from '@features/project/ProjectDetail'

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'projects', element: <ProjectListing /> },
      { path: 'projects/:id', element: <ProjectDetail /> },
      { path: 'account/security', element: <ChangePasswordPage /> },
      { path: 'admin/users', element: <UsersPage /> },
      { path: 'admin/subsidiaries', element: <SubsidiaryManagement /> }
    ]
  },
  { path: '/login', element: <GuestRoute><LoginPage /></GuestRoute> },
  {
    path: '/verify-email',
    element: (
      <EmailVerifyRoute>
        <VerifyEmailPage />
      </EmailVerifyRoute>
    )
  },
  { path: '/mfa', element: <MfaRoute><MfaPage /></MfaRoute> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> }
  ,{ path: '/logout', element: <LogoutPage /> }
])

export function AppRouter() {
  return <RouterProvider router={router} />
}
